import { IGroupGiftOrder, IGroupGiftOrdersParams, IGroupGiftOrdersResponse } from 'interfaces/bizGift';
import { storeClient } from './apiClients';

// 단체선물대장 공급처 주문 목록 조회
export const getGroupGiftOrders = async (params: IGroupGiftOrdersParams): Promise<IGroupGiftOrdersResponse> => {
  const { data } = await storeClient.get('group-gift-order/v1/orders', { params });
  return data;
};

// 단체선물대장 공급처 주문내역 엑셀 다운로드
export const downloadGroupGiftOrdersExcel = async (params: unknown) => {
  const { data } = await storeClient.post('group-gift-order/v1/orders/excel', params);
  return data;
};

// 단체선물대장 공급처 주문 송장번호 등록
export const saveGroupGiftTrackingNumber = async (saveData: unknown) => {
  const { data } = await storeClient.post('group-gift-order/v1/tracking-number', saveData);
  return data;
};

// 단체선물대장 공급처 주문 단건 상세
export const getGroupGiftOrderDetail = async (groupGiftOrderIdx: number | string): Promise<IGroupGiftOrder> => {
  const { data } = await storeClient.get(`group-gift-order/v1/orders/${groupGiftOrderIdx}`);
  return data;
};

// 단체선물대장 공급처 주문 단건 수정
export const updateGroupGiftOrder = async (groupGiftOrderIdx: number | string, saveData: unknown) => {
  const { data } = await storeClient.put(`group-gift-order/v1/orders/${groupGiftOrderIdx}`, saveData);
  return data;
};
